export enum Roles {
  CUSTOMER = "CUSTOMER",
  ADVISOR = "ADVISOR",
  BOOKKEEPER = "BOOKKEEPER",
  CPA = "CPA",
  SPOUSE = "SPOUSE",
}
